import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import configureStore from './store';

import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';

import "react-datepicker/dist/react-datepicker.css";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import 'react-toastify/dist/ReactToastify.css';

import 'react-virtualized/styles.css';
import './assets/scss/style.scss';
import '@thefinpedia/thefinpedia-shared/canvas';
import '@thefinpedia/thefinpedia-shared/canvas.scss';

const RESIZE_OBSERVER_LOOP_ERRORS = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];
const swallowResizeObserverLoop = (event) => {
  const message = event?.message || event?.reason?.message;
  if (message && RESIZE_OBSERVER_LOOP_ERRORS.some((m) => message.includes(m))) {
    event.stopImmediatePropagation();
    if (typeof event.preventDefault === 'function') event.preventDefault();
  }
};
window.addEventListener('error', swallowResizeObserverLoop);
window.addEventListener('unhandledrejection', swallowResizeObserverLoop);

/* ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
); */

ReactDOM.render(
  <Provider store={configureStore()}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
serviceWorker.unregister();

